const CITIZENSHIP_STATUS_LIST = [
  {
    id: 'CITIZEN',
    label: 'Citizen/passport holder',
  },
  {
    id: 'PERMANENT_RESIDENT',
    label: 'Permanent resident',
  },
  {
    id: 'WORK_PERMIT',
    label: 'Work permit/visa holder',
  },
  {
    id: 'NOT_AUTHORIZED_FOR_WORK',
    label: 'Not currently authorised to work',
  },
]

export default CITIZENSHIP_STATUS_LIST
